<template lang="pug">
	.asset-video-upload-info(v-if="showed && upload" v-window)
		.card
			.card-header
				i.fa.fa-film
				span Upload Info
				span.date {{new Date(upload["date"]).toLocaleDateString()}} {{new Date(upload["date"]).toLocaleTimeString()}}
			.card-body.collapse.show
				.form-line.upload.separator
					.videos(:class="{centered: true}")
						.video
							video(:src="`project-assets/project-${upload[\"creative_id\"]}/version-${upload[\"version_id\"]}/${upload[\"file_name\"]}`" controls autoplay loop muted playsinline)
				.form-actions
					button.btn.btn-danger(type="button" @click="deleteUpload($event)")
						i.fa.fa-remove
						span Delete upload
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	export default {
		name: "AssetVideoUploadInfo",
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show AssetVideoUploadInfo": function(variation, upload, asset) {

					this.variation = variation;
					this.upload = upload;
					this.asset = asset;

					this.creative = Creative.SelectedCreative;

					this.update();

				}
			}
		},
		data() {

			this.upload = null;
			this.asset = null;

			return {

			}

		},
		methods: {
			collectData() {

			},
			deleteUpload(e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete upload',
					message: `Are you sure you want to delete this uploaded file?`,
					confirmButtonText: '&nbsp;&nbsp;Delete upload',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteUpload: {
								assetUploadId: this.upload.id
							}
						});
						this.closeWindow();
					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.asset-video-upload-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.card-header
				display: flex
				flex-direction: row

				.date
					color: rgba(255,255,255,0.1)
					margin-left: auto

		.form-line
			display: flex
			flex-direction: row

		.upload
			flex-direction: column
			padding-bottom: 7px

		.videos
			display: flex
			flex-direction: row
			padding: 10px

			&.centered
				justify-content: center

			.video
				position: relative
				display: flex
				justify-content: center

				video
					max-width: 100%
					max-height: 60vh
					border-radius: 5px
					border: 1px solid var(--gray-dark)
					box-shadow: 0px 0px 5px var(--gray-dark)
					background-color: #000

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

	.asset-video-upload-info.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
